import type { InvestorOpportunityStage, InvestorType } from '../../services/investorCrm/investorsService';
import type { InvestorActivityType } from '../../services/investorCrm/activitiesService';

export const INVESTOR_STAGE_OPTIONS: Array<{ value: InvestorOpportunityStage; label: string }> = [
  { value: 'prospecting', label: 'Prospecting' },
  { value: 'warm_intro', label: 'Warm intro' },
  { value: 'first_meeting', label: 'First meeting' },
  { value: 'diligence', label: 'Due diligence' },
  { value: 'term_sheet', label: 'Term sheet' },
  { value: 'committed', label: 'Committed' },
  { value: 'closed_won', label: 'Closed won' },
  { value: 'closed_lost', label: 'Closed lost' }
];

export const INVESTOR_TYPE_OPTIONS: Array<{ value: InvestorType; label: string }> = [
  { value: 'individual', label: 'Individual' },
  { value: 'angel_group', label: 'Angel group' },
  { value: 'venture_capital', label: 'Venture capital' },
  { value: 'private_equity', label: 'Private equity' },
  { value: 'family_office', label: 'Family office' },
  { value: 'corporate_venture', label: 'Corporate venture' },
  { value: 'accelerator_incubator', label: 'Accelerator / incubator' },
  { value: 'sovereign_wealth', label: 'Sovereign wealth' },
  { value: 'other', label: 'Other' }
];

export const INVESTOR_ACTIVITY_OPTIONS: Array<{ value: InvestorActivityType; label: string }> = [
  { value: 'intro_call', label: 'Intro call' },
  { value: 'pitch', label: 'Pitch meeting' },
  { value: 'diligence', label: 'Diligence review' },
  { value: 'update', label: 'Investor update' },
  { value: 'email', label: 'Email' },
  { value: 'meeting', label: 'Meeting' },
  { value: 'note', label: 'Internal note' },
  { value: 'other', label: 'Other' }
];
